module.exports = __webpack_public_path__ + "img/header-background-1600.89ccb56.svg";